
export const withShowMoreHandler = (formatter: Function) => {
  return ({ row }: any) => {
    if (row?.isShowMoreRow === true) return null;
    if (row?.isParent === true) return null;
    if (row?.isParent === true) return null;
    return formatter({ row });
  };
};

